import {
  Button,
  Card,
  Checkbox,
  Chip,
  CircularProgress,
  Modal,
  Tooltip,
  Typography,
  Divider,
} from "@material-ui/core";
import {
  ArrowBendDownRight,
  CaretDown,
  CaretUp,
  Clock,
  Info,
  PaperPlaneTilt,
  PencilSimple,
  Plus,
  X,
} from "phosphor-react";
import React, { useState } from "react";
import * as Icon from "react-feather";
import { fdelete } from "../../../../API/callsAPI";
import PostEditor from "../../../PostEditor/postEditor";
import DateAndTimeViewer from "../../DateAndTimeViewer/DateAndTimeViewer.component";
import DeleteModal from "../../DeleteModal/DeleteModal.component";
import ErrorOrSuccessMessage from "../../ErrorOrSuccessMessage/ErrorOrSuccessMessage.component";
import UserAvatar from "../../UserAvatar/UserAvatar.component";
import useStyles from "./CommentOverview.styles";
import SkeletonDiv from "./SkeletonDiv";
import ReviewAgentIcon from "../../Svg/ReviewAgentIcon";
import ReviewAgentModal from "../ReviewAgentModal/ReviewAgentModal";
import LoaderSvg from "../../Svg/LoaderSvg";

// make dragable comment here
// add skeleton loader as well
export default function CommentsOverview({
  commentList,
  setCommentList,
  loggedInUser,
  fetchComments,
  allUsersName,
  handleSubmit,
  changeSeekTime,
  matchHeight,
  commentsPageNo,
  setCommentsPageNo,
  currentTime,
  showTimeStamp,
  selectedVersion,
  commentFilter,
  changeCommentFilter,
  editComment,
}) {
  const [open, setOpen] = useState(false);
  const [displayImage, setDisplayImage] = useState(null);
  const [selectedComment, setSelectedComment] = useState();
  const [isDeleteCommentModalOpen, setDeleteCommentModalOpen] = useState(false);
  const [repliedTo, setRepliedTo] = useState({});
  const [showReplyBox, setShowReplyBox] = useState(false);
  const [snackValue, setSnackValue] = useState({
    isOpen: false,
    message: "",
    isError: false,
  });
  const [attachmentImage, setAttachmentImage] = useState(null);
  const [addingComment, setAddingComment] = useState(false);
  const [resetCommentText, setResetCommentText] = React.useState(0);
  const [isTimeStampChecked, setIsTimeStampChecked] = useState(true);
  const [isReviewAgent, setReviewAgent] = useState(false);
  const [selectedComments, setSelectedComments] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  let mentionsRef = React.createRef();
  let replyRef = React.createRef();
  const classes = useStyles();

  const handleShowFilter = () => {
    setShowFilters(!showFilters);
  };

  const handleReviewAgent = () => {
    setReviewAgent(!isReviewAgent);
  };

  const deleteComment = (comment) => {
    setSelectedComment(comment.id);
    setDeleteCommentModalOpen(true);
  };

  let changeColor;
  const scrollTo = (comment) => {
    if (changeColor !== null) clearTimeout(changeColor);
    const scrollItem = document.getElementById(comment?.replied_to?.id);
    if (scrollItem) {
      scrollItem.scrollIntoView({ behavior: "smooth", block: "start" });
      if (scrollItem?.style) {
        scrollItem.style.backgroundColor = "#252A38";
      }
    }
    changeColor = setTimeout(() => {
      if (scrollItem?.style) {
        scrollItem.style.backgroundColor = "#1B1D28";
      }
    }, 5000);
  };

  const handleDeleteComment = async () => {
    try {
      await fdelete({
        url: `trackables/trackable-comment/${selectedComment}/`,
      });
      const res = await fetchComments();
      setCommentList({
        data: res?.comments,
        loading: false,
        isNextAvailable: res.isNextAvailable,
      });
      setDeleteCommentModalOpen(false);
      setSnackValue({
        isOpen: true,
        message: `SuccessFully deleted comment`,
        isError: false,
      });
      return "deleted";
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
    }
  };

  function handleStopPropogation(event) {
    event.stopPropagation();
  }

  const getTimeStamp = () => {
    return isTimeStampChecked && currentTime !== "00:00" && currentTime > 0
      ? currentTime
      : "";
  };
  const addNewComment = async () => {
    if (!mentionsRef.current.toHtml()) {
      return;
    }
    setAddingComment(true);
    try {
      const newCommentRes = await handleSubmit({
        description: getTimeStamp() + mentionsRef.current.toHtml(),
        mentions: mentionsRef.current.onExtractMentions(),
        attachmentImage: attachmentImage,
        timestamp: getTimeStamp(),
      });
      setAttachmentImage(null);
      if (newCommentRes) {
        mentionsRef.current?.reset();
        const commentsRes = await fetchComments();
        setAddingComment(false);
        setCommentList({
          data: commentsRes?.comments,
          loading: false,
          isNextAvailable: commentsRes?.isNextAvailable,
        });
        setResetCommentText(resetCommentText + 1);
        scrollTo(newCommentRes);
      }
    } catch (error) {
      console.log(error);
      setAddingComment(false);
    }
  };

  const replyComment = async () => {
    if (!replyRef.current.toHtml()) {
      return;
    }
    setAddingComment(true);
    try {
      const replyCommentRes = await handleSubmit({
        description: replyRef?.current?.toHtml(),
        mentions: replyRef?.current?.onExtractMentions(),
        repliedTo,
        timestamp: getTimeStamp(),
      });
      setAttachmentImage(null);
      if (replyCommentRes) {
        replyRef?.current?.reset();
        setShowReplyBox(false);
        const commentsRes = await fetchComments();
        setAddingComment(false);
        setCommentList({
          data: commentsRes?.comments,
          loading: false,
          isNextAvailable: commentsRes?.isNextAvailable,
        });
        setResetCommentText(resetCommentText + 1);
        scrollTo(replyCommentRes);
      }
    } catch (error) {
      console.log(error);
      setAddingComment(false);
    }
  };

  const updateComment = async () => {
    if (!mentionsRef.current.toHtml()) {
      return;
    }
    setIsEditing(false);
    setAddingComment(true);
    try {
      const editedComment = await editComment(
        selectedComment.id,
        selectedComment.timestamp + mentionsRef.current.toHtml(),
        selectedComment.timestamp,
      );
      if (editedComment) {
        setAttachmentImage(null);
        setSelectedComment(null);
        replyRef?.current?.reset();
        const commentsRes = await fetchComments();
        setAddingComment(false);
        setCommentList({
          data: commentsRes?.comments,
          loading: false,
          isNextAvailable: commentsRes?.isNextAvailable,
        });
        setResetCommentText(resetCommentText + 1);
        scrollTo(editedComment);
      }
    } catch (error) {
      console.log(error);
      setAddingComment(false);
    }
  };

  function formatTime(seconds) {
    var minutes = Math.floor(seconds / 60);
    var remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  }

  return (
    <>
      <ErrorOrSuccessMessage snackValue={snackValue} />
      {commentList.data.length === 0 && !commentList.loading ? (
        <div style={{ height: "90%" }}>
          <Typography>0 Comments</Typography>
          <div className={classes.noCommentContainer}>
            <Typography className={classes.noCommentContainerText}>
              Add a comment to get started with the review process.
            </Typography>
            <LoaderSvg />
          </div>
        </div>
      ) : (
        <div style={{ height: "90%" }}>
          {!commentList.loading && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Button
                endIcon={
                  showFilters ? (
                    <CaretUp weight="fill" size={16} />
                  ) : (
                    <CaretDown weight="fill" size={16} />
                  )
                }
                onClick={handleShowFilter}
              >
                Filters
              </Button>
              <div className={classes.comment}>
                {selectedComments.length > 0 ? (
                  <Tooltip title="Clear All">
                    <Button onClick={() => setSelectedComments([])}>
                      <X size={20} />
                    </Button>
                  </Tooltip>
                ) : (
                  <Tooltip title="Select comments to generate To Do’s">
                    <Info size={20} />
                  </Tooltip>
                )}
                <div className={classes.comment}>
                  {selectedComments.length > 0 && (
                    <Typography>{selectedComments.length} Selected</Typography>
                  )}
                  <Button
                    onClick={handleReviewAgent}
                    startIcon={<ReviewAgentIcon />}
                    className={classes.btn}
                  >
                    Review Agent
                  </Button>
                </div>
              </div>
            </div>
          )}
          {showFilters && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                margin: "5px 0px",
              }}
            >
              {/* <FormControl variant="outlined" className={classes.formControl}>
              <div className={classes.dropdownDiv}>
                <text className={classes.selectText}>
                  
                  {userFilter[1] !== "None" ? userFilter[1] : "All Users"}
                </text>
                <CaretDown weight="fill" className={classes.arrowIcon} />
              </div>
              <Select
                style={{ height: "0%", opacity: "0" }}
                className={classes.formLabelText}
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={userFilter}
                onChange={(event) => {
                  setCurrentCommentPage(1);
                  setUserFilter(event.target.value);
                }}
                label="Select User"
                defaultValue="none"
                MenuProps={{
                  classes: {
                    paper: classes.dropDown,
                  },
                }}
              >
                <MenuItem value={["", "None"]}>
                  <span style={{ fontSize: "14px" }}>None</span>
                </MenuItem>

                {allUsersName &&
                  allUsersName.map((user) => (
                    <MenuItem
                      value={[user.id, user.name]}
                      key={user.id}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        backgroundColor:
                          user.id === userFilter[0] && "#EEEEEE14",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        <UserAvatar
                          avatar2={true}
                          avatar={user.avatar}
                          firstName={user.first_name}
                          lastName={user.last_name}
                        />{" "}
                        <span style={{ fontSize: "14px" }}>{user.name}</span>
                      </div>
                      <div className={classes.emailText}>{user.email}</div>
                    </MenuItem>
                  ))}
              </Select>
            </FormControl> */}
              <Button
                className={
                  commentFilter === "timestamp" ||
                  commentFilter === "-timestamp"
                    ? classes.highlightedBtn
                    : classes.simpleBtn
                }
                onClick={() => {
                  setCommentsPageNo(1);
                  if (commentFilter === "timestamp") {
                    changeCommentFilter("-timestamp");
                  } else {
                    changeCommentFilter("timestamp");
                  }
                }}
              >
                Timestamps
              </Button>
              <Button
                className={
                  commentFilter === "created_at" ||
                  commentFilter === "-created_at"
                    ? classes.highlightedBtn
                    : classes.simpleBtn
                }
                onClick={() => {
                  setCommentsPageNo(1);
                  if (commentFilter === "created_at") {
                    changeCommentFilter("-created_at");
                  } else {
                    changeCommentFilter("created_at");
                  }
                }}
              >
                Commented On
              </Button>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <CaretUp
                  size={15}
                  className={
                    commentFilter === "timestamp" ||
                    commentFilter === "created_at"
                      ? classes.highlightedIcon
                      : classes.simpleIcon
                  }
                />
                <CaretDown
                  size={15}
                  className={
                    commentFilter === "-timestamp" ||
                    commentFilter === "-created_at"
                      ? classes.highlightedIcon
                      : classes.simpleIcon
                  }
                />
              </div>
            </div>
          )}
          <div
            style={{
              height: matchHeight ? "calc(100% - 107px)" : "calc(100% - 97px)",
              overflowY: "scroll",
              marginBottom: "12px",
            }}
          >
            {/* single comment */}
            {commentList.loading ? (
              <div style={{ margin: "15px 5px" }}>
                {/* calling this component 3 times to fill up comments area */}
                <SkeletonDiv />
                <SkeletonDiv />
                <SkeletonDiv />
              </div>
            ) : (
              commentList.data.map((eachComment) => (
                <SingleComment
                  eachComment={eachComment}
                  key={eachComment?.id}
                  loggedInUser={loggedInUser}
                  setRepliedTo={setRepliedTo}
                  setShowReplyBox={setShowReplyBox}
                  deleteComment={deleteComment}
                  setOpen={setOpen}
                  setDisplayImage={setDisplayImage}
                  changeSeekTime={changeSeekTime}
                  addSelectedComment={(currentComment) =>
                    setSelectedComments((prev) => [...prev, currentComment])
                  }
                  removeSelectedComment={(currentComment) => {
                    const filteredComment = selectedComments.filter(
                      (eachComment) => currentComment !== eachComment,
                    );
                    setSelectedComments(filteredComment);
                  }}
                  selectedComments={selectedComments}
                  handleStopPropogation={handleStopPropogation}
                  setSelectedComment={setSelectedComment}
                  setIsEditing={setIsEditing}
                  mentionsRef={mentionsRef}
                  setAttachmentImage={setAttachmentImage}
                />
              ))
            )}
            <div
              className={classes.flexCenter}
              style={{
                display: commentList?.isNextAvailable ? "flex" : "none",
              }}
            >
              <Button
                className={classes.showMoreButton}
                onClick={() => setCommentsPageNo(commentsPageNo + 1)}
                startIcon={<Plus />}
              >
                See More
              </Button>
            </div>
          </div>
        </div>
      )}
      {showReplyBox ? (
        <div style={{ position: "relative" }} onKeyDown={handleStopPropogation}>
          <div
            style={{
              display: "flex",
            }}
          >
            <div style={{ height: "40px" }}>
              {attachmentImage ? (
                <Chip
                  avatar={
                    <img
                      src={
                        attachmentImage ||
                        "https://fastly.picsum.photos/id/175/200/200.jpg?hmac=5rzD884Hqi9oWr_n5vg0XSc9f6yMlPotvKa8Y0cVzd4"
                      }
                      style={{
                        height: "40px",
                        width: "40px",
                        objectFit: "cover",
                      }}
                      alt=""
                    />
                  }
                  style={{ borderRadius: "10px", height: "45px" }}
                  variant="outlined"
                  onDelete={() => {
                    setAttachmentImage(null);
                  }}
                ></Chip>
              ) : (
                ""
              )}
            </div>
            <div className={classes.replyCommentField}>
              <div>
                <Card
                  className={classes.replyCard}
                  onClick={() => {
                    scrollTo(repliedTo);
                  }}
                >
                  {repliedTo.attachment ? (
                    <img
                      // className={classes.AssetImage}
                      onClick={() => {
                        setOpen(true);
                        setDisplayImage(repliedTo.attachment);
                      }}
                      alt="projectImage"
                      src={repliedTo.attachment}
                      height="50px"
                      width="50px"
                      onContextMenu={(e) => e.preventDefault()}
                    />
                  ) : null}
                  <span
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      width: "92%",
                      height: "30px",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: repliedTo.description
                        .replace(/<p>/g, "<div>")
                        .replace(/<\/p>/g, "</div>")
                        .replace("0:0", ""),
                    }}
                  ></span>
                  <div
                    onClick={() => {
                      setShowReplyBox(false);
                    }}
                  >
                    <Icon.X size={20} />
                  </div>
                </Card>
              </div>
              <PostEditor
                placeholder={"Type a Comment..."}
                mentions={allUsersName}
                ref={replyRef}
                handleAddImageAttachment={(image) => setAttachmentImage(image)}
                handleFilePaste={(file) => {
                  setAttachmentImage(URL.createObjectURL(file[0]));
                }}
                handleSubmit={() => replyComment()}
                resetPrevious={resetCommentText}
              />
            </div>
            <Button
              className={classes.submitButton}
              onClick={() => replyComment()}
              disabled={addingComment ? true : false}
            >
              {addingComment ? (
                <CircularProgress size={20} />
              ) : (
                <PaperPlaneTilt size={22} />
              )}
            </Button>
          </div>
        </div>
      ) : (
        <div
          style={{ display: "flex", position: "relative" }}
          onKeyDown={handleStopPropogation}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              height: attachmentImage ? "150px" : "100px",
              marginTop: attachmentImage ? "-80px" : "-50px",
            }}
          >
            {attachmentImage && (
              <div style={{ height: "40px", width: "100%" }}>
                <Chip
                  avatar={
                    <img
                      src={
                        attachmentImage ||
                        "https://fastly.picsum.photos/id/175/200/200.jpg?hmac=5rzD884Hqi9oWr_n5vg0XSc9f6yMlPotvKa8Y0cVzd4"
                      }
                      style={{
                        height: "40px",
                        width: "100%",
                        objectFit: "cover",
                      }}
                      alt=""
                    />
                  }
                  style={{
                    borderRadius: "10px",
                    height: "45px",
                    width: "100%",
                  }}
                  variant="outlined"
                  onDelete={() => {
                    setAttachmentImage(null);
                  }}
                ></Chip>
              </div>
            )}

            <div
              className={
                attachmentImage
                  ? classes.submitCommentFieldWithAttachment
                  : classes.submitCommentField
              }
            >
              {showTimeStamp ? (
                <div className={classes.timeStampDiv}>
                  <Clock />
                  <span>
                    {selectedComment && isEditing
                      ? formatTime(selectedComment.timestamp)
                      : formatTime(currentTime !== "00:00" ? currentTime : 0)}
                  </span>
                  <Checkbox
                    checked={isTimeStampChecked}
                    size="small"
                    onClick={() => setIsTimeStampChecked(!isTimeStampChecked)}
                    style={{
                      padding: "0px",
                    }}
                  />
                </div>
              ) : (
                ""
              )}
              <PostEditor
                placeholder={"Type a Comment..."}
                mentions={allUsersName}
                ref={mentionsRef}
                handleAddImageAttachment={(image) => setAttachmentImage(image)}
                handleFilePaste={(file) => {
                  setAttachmentImage(URL.createObjectURL(file[0]));
                }}
                handleSubmit={() => {
                  if (isEditing) {
                    updateComment();
                  } else {
                    addNewComment();
                  }
                }}
                resetPrevious={resetCommentText}
              />
            </div>
          </div>
          <Button
            className={classes.submitButton}
            onClick={() => {
              if (isEditing) {
                updateComment();
              } else {
                addNewComment();
              }
            }}
            disabled={addingComment ? true : false}
          >
            {addingComment ? (
              <CircularProgress size={20} />
            ) : (
              <PaperPlaneTilt size={22} />
            )}
          </Button>
        </div>
      )}

      <div>
        <Modal
          open={open}
          onClose={() => setOpen(false)}
          className={classes.flexCenter}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              outline: "none",
              height: "80vh",
              width: "65%",
            }}
          >
            <Icon.X
              style={{ alignSelf: "flex-end", cursor: "pointer" }}
              onClick={() => setOpen(false)}
            />
            <img
              src={displayImage}
              height="90%"
              width="100%"
              onContextMenu={(e) => e.preventDefault()}
              alt="from annotate"
            ></img>
          </div>
        </Modal>
      </div>
      <div>
        <Modal
          className={classes.flexCenter}
          open={isDeleteCommentModalOpen}
          onClose={() => setDeleteCommentModalOpen(false)}
        >
          <DeleteModal
            type="Comment"
            name={selectedComment}
            handleCloseDeleteModal={() => {
              setDeleteCommentModalOpen(false);
            }}
            handleDelete={handleDeleteComment}
          />
        </Modal>
      </div>
      <Modal
        className={classes.flexCenter}
        open={isReviewAgent}
        onClose={handleReviewAgent}
      >
        <ReviewAgentModal
          handleClose={() => {
            handleReviewAgent();
            setSelectedComments([]);
          }}
          versionId={selectedVersion.id}
          trackableType={
            selectedVersion.asset === undefined ? "shotversion" : "assetversion"
          }
          selectedComments={selectedComments}
        />
      </Modal>
    </>
  );
}

const SingleComment = ({
  eachComment,
  loggedInUser,
  setRepliedTo,
  setShowReplyBox,
  deleteComment,
  setDisplayImage,
  setOpen,
  changeSeekTime,
  addSelectedComment,
  removeSelectedComment,
  selectedComments,
  handleStopPropogation,
  setSelectedComment,
  setIsEditing,
  mentionsRef,
  setAttachmentImage,
}) => {
  const classes = useStyles();
  const [showReplies, setShowReplies] = useState(false);

  const getDisplayTime = (time) => {
    if (time.includes(":")) {
      return time;
    }
    let seconds = 0;
    let minutes = 0;
    if (time % 60) {
      minutes = parseInt(time / 60);
      seconds = parseInt(time % 60);
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }
    }
    return `${minutes}:${seconds}`;
  };

  const userObj = {
    avatar: eachComment.author && eachComment.author.avatar,
    first_name:
      eachComment.author && eachComment.author.first_name
        ? eachComment.author.first_name
        : "",
    last_name:
      eachComment.author && eachComment.author.last_name
        ? eachComment.author.last_name
        : "",
  };

  return (
    <>
      <div
        id={eachComment.id}
        className={
          selectedComments.indexOf(eachComment.id) !== -1
            ? classes.selectedComment
            : classes.notSelectedComment
        }
        onClick={() => {
          if (selectedComments.indexOf(eachComment.id) === -1) {
            addSelectedComment(eachComment.id);
          } else {
            removeSelectedComment(eachComment.id);
          }
        }}
      >
        <div className={classes.commentHead}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <UserAvatar
              avatar={userObj.avatar}
              firstName={userObj.first_name}
              lastName={userObj.last_name}
            />
            <span className={classes.userName}>
              {userObj.first_name} {userObj.last_name}
            </span>
          </div>
          <span className={classes.time}>
            <DateAndTimeViewer dateAndTime={eachComment.created_at} />
          </span>
        </div>

        <div
          style={{
            marginLeft: "40px",
            padding: "8px 0px",
          }}
        >
          {/* add show more on big comments */}
          <div style={{ display: "flow" }}>
            {eachComment?.description?.split("<p>")[0] ? (
              <span
                className={classes.annotationText}
                onClick={(e) => {
                  handleStopPropogation(e);
                  changeSeekTime(eachComment?.description?.split("<p>")[0]);
                }}
              >
                {getDisplayTime(eachComment?.description?.split("<p>")[0])}
              </span>
            ) : null}
            <span
              className={classes.commentText}
              dangerouslySetInnerHTML={{
                __html: eachComment?.description
                  .split("<p>")[1]
                  ?.replace("<p>", "<div>")
                  ?.replace("</p>", "</div>"),
              }}
            />
          </div>
        </div>

        {eachComment.attachment ? (
          <img
            className={classes.image}
            onClick={(e) => {
              handleStopPropogation(e);
              setOpen(true);
              setDisplayImage(eachComment.attachment);
            }}
            alt="projectImage"
            src={eachComment.attachment}
            height="190px"
            width="358px"
            onContextMenu={(e) => e.preventDefault()}
          />
        ) : null}
        <div
          className={classes.flexBetween}
          style={{ margin: "4px 0px 4px 40px" }}
        >
          <div>
            <Button
              onClick={(e) => {
                handleStopPropogation(e);
                setShowReplies(!showReplies);
              }}
              className={classes.showHideButton}
              disabled={eachComment?.replies?.length ? false : true}
            >
              {eachComment?.replies?.length ? (
                <>
                  {showReplies
                    ? "Hide Replies"
                    : `Show ${eachComment?.replies?.length} Replies`}
                </>
              ) : (
                "No Replies"
              )}
            </Button>
          </div>
          <div className={classes.buttons}>
            <Tooltip title="Reply" placement="top-start">
              <Button
                className={classes.commonIconButton}
                onClick={(e) => {
                  handleStopPropogation(e);
                  setRepliedTo(eachComment);
                  setShowReplyBox(true);
                }}
              >
                <Icon.CornerDownLeft style={{ hight: "16px", width: "16px" }} />
              </Button>
            </Tooltip>
            {eachComment.author.id === loggedInUser?.id && (
              <Tooltip title="Edit Comment" placement="top-start">
                <Button
                  className={classes.commonIconButton}
                  onClick={(e) => {
                    handleStopPropogation(e);
                    const cleanContent = eachComment.description
                      .split("<p>")[1]
                      ?.replace("<p>", "")
                      ?.replace("</p>", "");
                    setSelectedComment(eachComment);
                    setIsEditing(true);
                    mentionsRef.current?.setContent(cleanContent);
                    setAttachmentImage(eachComment.attachment);
                  }}
                >
                  <PencilSimple size={18} />
                </Button>
              </Tooltip>
            )}
            {eachComment.author.id === loggedInUser?.id && (
              <Tooltip title="Delete Comment" placement="top-start">
                <Button
                  className={classes.commonIconButton}
                  onClick={(e) => {
                    handleStopPropogation(e);
                    deleteComment(eachComment);
                  }}
                >
                  <Icon.Trash2 style={{ hight: "16px", width: "16px" }} />
                </Button>
              </Tooltip>
            )}
          </div>
        </div>
        <Divider />
      </div>
      <div
        style={{
          marginLeft: "20px",
          maxHeight: showReplies ? "300px" : "0px",
          overflowY: "auto",
          marginRight: "6px",
          transition: "max-height 0.5s ease-in-out",
        }}
      >
        {eachComment?.replies?.map((single) => (
          <SingleReply
            single={single}
            eachComment={eachComment}
            loggedInUser={loggedInUser}
            deleteComment={deleteComment}
            selectedComments={selectedComments}
            addSelectedComment={addSelectedComment}
            removeSelectedComment={removeSelectedComment}
            handleStopPropogation={handleStopPropogation}
            setSelectedComment={setSelectedComment}
            setIsEditing={setIsEditing}
            mentionsRef={mentionsRef}
          />
        ))}
      </div>
    </>
  );
};

const SingleReply = ({
  single,
  deleteComment,
  eachComment,
  loggedInUser,
  addSelectedComment,
  removeSelectedComment,
  selectedComments,
  handleStopPropogation,
  setSelectedComment,
  setIsEditing,
  mentionsRef,
}) => {
  const classes = useStyles();

  const userObj = {
    avatar: single.author && single.author.avatar,
    first_name:
      single.author && single.author.first_name ? single.author.first_name : "",
    last_name:
      single.author && single.author.last_name ? single.author.last_name : "",
  };

  return (
    <div
      id={single.id}
      className={
        selectedComments.indexOf(single.id) !== -1
          ? classes.selectedComment
          : classes.notSelectedComment
      }
      onClick={() => {
        if (selectedComments.indexOf(single.id) === -1) {
          addSelectedComment(single.id);
        } else {
          removeSelectedComment(single.id);
        }
      }}
    >
      <div className={classes.commentHead}>
        <div className={classes.repliesHead}>
          <ArrowBendDownRight size={20} className={classes.colorText} />
          <UserAvatar
            avatar={userObj.avatar}
            firstName={userObj.first_name}
            lastName={userObj.last_name}
          />

          <span style={{ margin: "0px 2px" }} className={classes.commentText}>
            {userObj.first_name} {userObj.last_name}
          </span>
        </div>
        <span className={classes.time}>
          <DateAndTimeViewer dateAndTime={eachComment.created_at} />
        </span>
      </div>

      <div className={classes.replyDescription}>
        {/* add show more on big comments */}
        <span
          className={classes.commentText}
          dangerouslySetInnerHTML={{
            __html: single?.description?.split("<p>")[1]?.split("</p>")[0],
          }}
        />
      </div>
      <div className={classes.replyIcons}>
        {/* <Button className={classes.commonIconButton}>
          <ThumbsUp size={20} />
        </Button> */}
        {single.author.id === loggedInUser?.id && (
          <Tooltip title="Edit Comment" placement="top-start">
            <Button
              className={classes.commonIconButton}
              onClick={(e) => {
                handleStopPropogation(e);
                const cleanContent = single.description
                  .split("<p>")[1]
                  ?.replace(/<movcolab[^>]*>.*?<\/movcolab>/g, "")
                  ?.replace("<p>", "")
                  ?.replace("</p>", "");
                setSelectedComment(single);
                setIsEditing(true);
                mentionsRef.current?.setContent(cleanContent);
              }}
            >
              <PencilSimple size={18} />
            </Button>
          </Tooltip>
        )}
        {single.author.id === loggedInUser?.id && (
          <Tooltip title="Delete Comment" placement="top-start">
            <Button
              className={classes.commonIconButton}
              onClick={(e) => {
                handleStopPropogation(e);
                deleteComment(single);
              }}
            >
              <Icon.Trash2 style={{ hight: "16px", width: "16px" }} />
            </Button>
          </Tooltip>
        )}
      </div>
      <Divider />
    </div>
  );
};
